export default "/assets/heart-white-solid.svg";